import { isIOS } from 'react-device-detect';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LazyLoadImg from '../../../commons/components/LazyLoadImg';
import SkeletonLoadingComponent from '../../../commons/components/SkeletonLoading';
import { BANNER_LINK } from '../../../commons/constans/banner';
import ROUTERS from '../../../commons/constans/router';
import SwiperSlide from './../../../commons/components/Slider';

const Banner = ({ images = [], isProcessing = false }) => {
  const navigate = useNavigate();
  const goToGiftboxPoint = () => {
    navigate(ROUTERS.GIFTBOX_POINT);
  };

  const goToGiftboxPointHistory = () => {
    navigate(ROUTERS.GIFTBOX_POINT_HISTORY);
  };

  const showLinkBanner = (data) => {
    let link = '/';
    if (data.type === 'APP') {
      link = `/${data.link_banner}`;
    } else {
      link = BANNER_LINK[data.type];
    }
    return link;
  };

  const handleCallOpenBrowser = (data) => {
    if (data.type === 'APP') {
      let url = data.link_banner;
      if (!url) return;
      let index = url.indexOf(process.env.REACT_APP_URL);
      if (index > -1) {
        let path = url.replace(process.env.REACT_APP_URL, '');
        navigate(path);
      } else {
        window.callOpenBrowserNative(url);
      }
    } else {
      window.nativeOpenCamera();
    }
  };


  return (
    <>
      {isProcessing ? (
        <div className="header-main__banner"  style={{height: 279}}>
          <h3 className="title-banner">
            <SkeletonLoadingComponent width={220} height={20} />
          </h3>
            <SwiperSlide
              spaceBetween={10}
              centeredSlides={true}
              autoplay
              delay={3000}
              slidesPerView={1.15}
              classSwiper={'show-banner'}
              // loop
            >
              <SkeletonLoadingComponent width={'100%'} height={200} cssClass={'banner-skeleton'}/>
              <SkeletonLoadingComponent width={'100%'} height={200} cssClass={'banner-skeleton'}/>
              <SkeletonLoadingComponent width={'100%'} height={200} cssClass={'banner-skeleton'}/>
            </SwiperSlide>
        </div>
      ) : images.length ? (
        <div className="header-main__banner">
          {images && images.length > 0 ? (
            <h3 className="title-banner">스포키즈의 새 소식을 확인해보세요!</h3>
          ) : (
            ''
          )}
          <SwiperSlide
            spaceBetween={10}
            centeredSlides={true}
            autoplay
            delay={3000}
            slidesPerView={1.15}
            classSwiper={'show-banner'}
            // loop
          >
            {
              images.map((img) => {
                if (img.type === 'APP' || img.type === 'CHARACTER_SELFIE') {
                  return (
                    <a
                      href={'#'}
                      key={img.id}
                      onClick={() => handleCallOpenBrowser(img)}
                    >
                      <LazyLoadImg src={img?.image_path_url?.original || ''} />
                      {/* <img src={img?.image_path_url?.original || ''} alt={img.name} /> */}
                    </a>
                  );
                } else {
                  return (
                    <Link to={showLinkBanner(img)} key={img.id}>
                      <LazyLoadImg src={img?.image_path_url?.original || ''} />
                      {/* <img src={img?.image_path_url?.original || ''} alt={img.name} /> */}
                    </Link>
                  );
                }
              })
            }
          </SwiperSlide>
          {/*<img src="/images/img_banner01.png" alt="" />*/}
        </div>
      ) : (
        <div className="header-main__box-use-history">
          <div className="box-use" onClick={goToGiftboxPoint}>
            <img src="/images/icon_box_barcode.svg" alt="" />
            <span>사용하기</span>
          </div>
          <div className="line"></div>
          <div className="box-history" onClick={goToGiftboxPointHistory}>
            <img src="/images/icon_box_list.svg" alt="" />
            <span>내역보기</span>
          </div>
        </div>
      )}
    </>
  );
};

export default Banner;
